import React, { memo, useState } from 'react'
import { Box, Stack, HStack, Text } from '@chakra-ui/react'
import { LogFilter } from './LogFilter'
import { LogRecords } from './LogRecords'
import { useDialerState } from '../dialer/dialer.hooks'
import { SelectOption } from 'types/transaction.type'

export enum FilterType {
  All = 'ALL',
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
  MISSED_CALL = 'MISSED',
  VOICE_MAIL = 'VOICEMAIL',
}

const OPTIONS = [
  { label: 'ALL', value: FilterType.All },
  { label: "Incoming Call", value: FilterType.INCOMING },
  { label: 'Outgoing Call', value: FilterType.OUTGOING },
  { label: 'Missed', value: FilterType.MISSED_CALL },
  { label: 'Voice Mail', value: FilterType.VOICE_MAIL },
]

type CallLogType = {}
export const CallLog: React.FC<CallLogType> = memo(() => {
  const [activeFilter, setActiveFilter] = useState<SelectOption>({ label: 'ALL', value: FilterType.All })
  const { dialerState } = useDialerState()

  if (dialerState.isOpen || dialerState.isCalling) return null

  return (
    <Box>
      <Stack>
        <HStack pos="relative" w="90%" left="20px" top="10px">
          <Box w="30%">
            <Text fontSize="16px" color="gray-700" fontWeight="500" lineHeight="28px">
              Logs
            </Text>
          </Box>
          <Box w="70%">
            <LogFilter options={OPTIONS} setActive={setActiveFilter} active={activeFilter} />
          </Box>
        </HStack>
        <LogRecords filter={activeFilter} />
      </Stack>
    </Box>
  )
})
